import { useEffect } from 'react';
import { PERSONA_PROFILE, type Praise as PraiseData } from '../praise';
import { PersonaAvatar } from './Avatars';

type Props = { praise: PraiseData; onDismiss: () => void };

export function Praise({ praise, onDismiss }: Props) {
  const { tier, lines } = praise;

  // 行が増えるぶんだけ表示時間を伸ばす
  useEffect(() => {
    const ms = 5200 + (lines.length - 1) * 1800;
    const timer = window.setTimeout(onDismiss, ms);
    return () => window.clearTimeout(timer);
  }, [lines.length, onDismiss]);

  return (
    <>
      <div className="praise-scrim" onClick={onDismiss} />
      <div className="praise-layer">
        <div
          className={`praise praise--t${tier}`}
          role="status"
          aria-live="polite"
          onClick={onDismiss}
          title="タップで閉じる"
        >
          <div className="praise__meter" aria-label={`強度 ${tier} / 5`}>
            {[1, 2, 3, 4, 5].map((n) => (
              <span key={n} className={`praise__seg${n <= tier ? ' praise__seg--on' : ''}`} />
            ))}
            <span className="praise__tier">INTENSITY {tier}</span>
          </div>

          {lines.map((line, i) => {
            const who = PERSONA_PROFILE[line.persona];
            return (
              <div
                className={`praise__line praise__line--${line.persona}`}
                key={`${line.persona}-${i}`}
                style={{ animationDelay: `${i * 1100}ms` }}
              >
                <div className="praise__avatar">
                  <PersonaAvatar persona={line.persona} tier={tier} size={104} />
                </div>
                <div className="praise__body">
                  <div className="praise__who">
                    <span className="praise__name">{who.name}</span>
                    <span className="praise__sub">{who.sub}</span>
                  </div>
                  <p className="praise__text">{line.text}</p>
                </div>
              </div>
            );
          })}

          <div className="praise__dismiss">タップで閉じる</div>
        </div>
      </div>
    </>
  );
}
